import { ButtonPosition } from '@/common/manager/position/button-position';
import { calculateTextExprValue, isArrayNotEmpty } from '@/common/util/util';
const componentLoopMap = {};
export const config = {
    value: 'tableLoop2',
    position: [
        ButtonPosition.form,
        ButtonPosition.formDialog,
        ButtonPosition.tableOperate,
        ButtonPosition.pageDidMount,
    ],
    action: (config) => {
        const { buttonConfig, _context, state, urlParamsDataSource } = config || {};
        const { options } = buttonConfig || {};
        const { _bindTable, active, interval, stopLoop } = options || {};
        function doStopLoop(id) {
            const stop = calculateTextExprValue(stopLoop, {
                urlParamsDataSource,
                recordDataSource: {},
                state,
            });
            const isLooping = componentLoopMap[id];
            if (stop === true && typeof isLooping === 'number') {
                clearInterval(isLooping);
                componentLoopMap[id] = undefined;
            }
        }
        function loopOneTable(id) {
            if (typeof id === 'string') {
                const table = _context.$(id);
                if (table) {
                    const isLooping = componentLoopMap[id];
                    if (isLooping === undefined &&
                        active &&
                        typeof interval === 'number') {
                        componentLoopMap[id] = setInterval(() => {
                            table.load?.();
                            table
                                ?.getRemoteOperation?.()
                                ?.current?.innerInfo?.setLoading?.(false);
                            doStopLoop(id);
                        }, interval * 1000);
                    }
                }
            }
        }
        if (isArrayNotEmpty(_bindTable) && _context) {
            _bindTable.forEach((item) => {
                loopOneTable(item);
            });
        }
    },
};
